import { Component, ViewChild } from '@angular/core';
import { FiltersM, typesApex } from '../../../components/models';
import { DataService } from '../../../services/data/data.service';
import { ComercialService, PERIODICITY, PerspectiveIdentifier } from '../../../services/comercial/comercial.service';
import { TranslateService } from '@ngx-translate/core';
import { formatear } from '../../funciones/funcionesGenerales';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import { firstValueFrom } from 'rxjs';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { FormaterNumberPipe } from '../../../services/pipes/formater-number.pipe';

@Component({
  selector: 'app-indicadores-a3',
  templateUrl: './indicadores-a3.component.html',
  styleUrl: './indicadores-a3.component.css',
  providers: [FormaterNumberPipe]
})
export class IndicadoresA3Component {
  Filters = FiltersM;
  periodos = [];
  month = 'Enero';
  selectAllSucursales = true;
  sucursales = [];
  skeleton = true;
  subtitles = '';
  subtitles2 = '';
  expandAll = true;

  periodoSelect = '';
  /** nombre sale del es.json (clave en "nombreKey"); se traduce al iniciar. */
  perspectives = [
    {
      name: '',
      nombreKey: 'comercial.colocacion.anexo3.creditos',
      check: true,
      columns: [
        { field: 'saldoBancoComunal' },
        { field: 'saldoMicroempresa' },
        { field: 'saldoPdc' },
        { field: 'clientesActivos' },
        { field: 'clientesCiclo1' },
        { field: 'reactivaciones' },
        { field: '%Pdc' },
        { field: 'clientesPdc' },
      ]
    },
    {
      name: '',
      nombreKey: 'comercial.colocacion.anexo3.captacion',
      check: false,
      columns: [
        { field: 'saldoCarteraAhorro' },
        { field: 'saldoCdpf' },
        { field: 'saldoRetirable' },
        { field: 'crecimiento' },
        { field: 'crecimientoP' },
      ]
    },
  ]

  regiones = [];
  tarjetas = [];
  tarjetasSkeleton = ['','','',''];
  viewTabla = true;
  modal = false;

  typeGraphic = typesApex;
  type: typesApex;
  data = [];
  labels = [];
  etiquetasShow = true;
  metricas: { index: number, name: string }[] = [];
  metricaIndex = 0;
  @ViewChild('graficas') graficas: GraficadorComponent;

  private token;
  private periodoInicial: any;
  constructor(
    public dataService: DataService,
    private readonly comercialService: ComercialService,
    private readonly translate: TranslateService,
    private excelService: ExcelService,
    private formaterPipe: FormaterNumberPipe,
  ){
    formatear.momentAbrev();
    this.getPeriods();
  }

  private async traducirPerspectivas(){
    for(const p of this.perspectives){
      p.name = await firstValueFrom(this.translate.get(p.nombreKey));
    }
  }

  private async getPeriods(){
    await this.traducirPerspectivas();
    const token = await firstValueFrom(this.comercialService.loginAleema());
    this.token = token['accessToken'];

    const periodos = await firstValueFrom(
      this.comercialService.getPeriodosAnexo3(this.token)
    );
    var auxYear = [];
    auxYear = this.comercialService.ordenarPeriodos(periodos['periods']).map(y => {
      return {
        anio: y.year,
        series: y.months.map(m => {
          return {
            mes: Meses.getMesesNumbertoString(m, true),
            mesS: Meses.getMesesNumbertoString(m, false),
            check: false,
            an: y.year,
            anio: (`${y.year}`).substring(2),
            periodo: Meses.getMesesNumbertoString(m, true)+' '+(`${y.year}`).substring(2),
            visible: true,
            utilizable: true,
          }
        }),
        visible: true,
        utilizable: true,
      }
    });

    const elegido = await this.comercialService.ultimoPeriodoConDatos(
      auxYear.flatMap(y => y.series),
      async periodo => {
        const r = await firstValueFrom(
          this.comercialService.getCreditoA3({
            perspective: PerspectiveIdentifier.REGION,
            period: periodo,
            granularity: PERIODICITY.MONTH
          }, this.token)
        );
        return r['results']?.length > 0;
      }
    );
    this.periodoInicial = elegido;
    elegido.check = true;
    this.periodos = auxYear;
    this.month = elegido.mesS;
    this.periodoSelect = elegido.periodo;

    const per = this.getPeriodo();
    const data = await firstValueFrom(
      this.comercialService.getCreditoA3({
        perspective: PerspectiveIdentifier.REGION,
        period: per,
        granularity: PERIODICITY.MONTH
      },this.token)
    );
    const regionesDes = data['results'];
    const regiones = regionesDes.sort((a, b) => {
      if (a.description === 'SIN REGION') return 1;
      if (b.description === 'SIN REGION') return -1;

      return a.description.localeCompare(b.description, 'es', {
        sensitivity: 'base',
      });
    });
    this.sucursales = regiones.map(r => {
      return {
        description: formatear.capitalizar(r.description),
        name: formatear.capitalizar(r.description),
        check: true,
      }
    });
    this.getData();
  }
  private async getData(){
    this.skeleton = true;
    const per = this.getPeriodo();
    const perAnt = this.getPeridoAnt();
    var data, dataAnt;
    if(this.perspectives[0].check){
      data = await firstValueFrom(
        this.comercialService.getCreditoA3({
          perspective: PerspectiveIdentifier.REGION,
          period: per,
          granularity: PERIODICITY.MONTH
        },this.token)
      );
    }else{
      data = await firstValueFrom(
        this.comercialService.getAhorrosA3({
          perspective: PerspectiveIdentifier.REGION,
          period: per,
          granularity: PERIODICITY.MONTH
        },this.token)
      );
      dataAnt = await firstValueFrom(
        this.comercialService.getAhorrosA3({
          perspective: PerspectiveIdentifier.REGION,
          period: perAnt,
          granularity: PERIODICITY.MONTH
        },this.token)
      );
    }
    const regionesDes = this.perspectives[0].check ? data['results']
    .map(r =>{
      r.measures ={
        ...r.measures,
        ['%Pdc']: (r.measures.saldoPdc/r.measures.carteraTotal)*100 
      }
      return {
        ...r
      }
    })
    :data['results']
    .map((r, i) => {
      const reg = dataAnt['results'].find(rA => rA.description === r.description);
      const saldoActual = r.measures.saldoCarteraAhorro ?? 0;
      const saldoAnterior = reg?.measures.saldoCarteraAhorro ?? 0;
      const cre = saldoActual-saldoAnterior;
      const creP = saldoAnterior === 0 ? 0: saldoActual / saldoAnterior;
      r.measures = {
        ...r.measures,
        crecimiento: cre,
        crecimientoP: (creP-1)*100,
      }
      return {
        ...r,
      }
    });
    const regiones = regionesDes.sort((a, b) => {
      if (a.description === 'SIN REGION') return 1;
      if (b.description === 'SIN REGION') return -1;

      return a.description.localeCompare(b.description, 'es', {
        sensitivity: 'base',
      });
    });
    for(const r of regiones){
      const filters = {
        [PerspectiveIdentifier.REGION]: [r.code]
      }

      var sucursales, sucursalesAnt;
      if(this.perspectives[0].check){
        sucursales = await firstValueFrom(
          this.comercialService.getCreditoA3({
            perspective: PerspectiveIdentifier.BRANCH_OFFICE,
            period: per,
            granularity: PERIODICITY.MONTH,
            filters
          },this.token)
        );
      }else{
        sucursales = await firstValueFrom(
          this.comercialService.getAhorrosA3({
            perspective: PerspectiveIdentifier.BRANCH_OFFICE,
            period: per,
            granularity: PERIODICITY.MONTH,
            filters
          },this.token)
        );
        sucursalesAnt = await firstValueFrom(
          this.comercialService.getAhorrosA3({
            perspective: PerspectiveIdentifier.BRANCH_OFFICE,
            period: perAnt,
            granularity: PERIODICITY.MONTH,
            filters
          },this.token)
        );
      }
      const sucursalesDes = this.perspectives[0].check ? sucursales['results']
      .map(r =>{
        r.measures ={
          ...r.measures,
          ['%Pdc']: (r.measures.saldoPdc/r.measures.carteraTotal)*100 
        }
        return {
          ...r
        }
      })
      :sucursales['results']
      .map((r, i) => {
        const reg = sucursalesAnt['results'].find(rA => rA.description === r.description);
        const saldoActual = r.measures.saldoCarteraAhorro ?? 0;
        const saldoAnterior = reg?.measures.saldoCarteraAhorro ?? 0;
        const cre = saldoActual-saldoAnterior;
        const creP = saldoAnterior === 0? 0: saldoActual / saldoAnterior;
        r.measures = {
          ...r.measures,
          crecimiento: cre,
          crecimientoP: creP===0?0:(creP-1)*100,
        }
        return {
          ...r,
        }
      });
      r['sucursales'] = sucursalesDes;
      r['sucursales'] = r['sucursales'].sort((a, b) =>
      a.description.localeCompare(b.description, 'es')
    );
      // Se capitaliza al final: antes se compara por description (período anterior, 'SIN REGION')
      r.description = formatear.capitalizar(r.description);
      r['sucursales'].forEach(s => s.description = formatear.capitalizar(s.description));
      r['check'] = true;
      r['visible'] = true;
    }
    this.regiones = regiones;
    this.recalcularData();
    this.skeleton = false;
  }
  private recalcularData(){
    this.sucursales.forEach((s, i) =>{
      this.regiones[i].visible = s.check;
    });
    const sumas = [];
    
    const per = this.perspectives.find(p => p.check);
    per.columns.forEach( p => {
      const suma = this.regiones.reduce( (acc, r) => acc+=r.check?r.measures[p.field]:0,0)
      sumas.push(suma)
    });

    this.tarjetas = sumas;
    this.getDataGrafica();
    this.getSubtitles();
  }
  private getDataGrafica(){
    const i = this.perspectives.findIndex(p => p.check);
    const columnas = this.perspectives[i].columns;

    this.metricas = columnas.map((c, j) => ({
      index: j,
      name: this.translate.instant(`comercial.colocacion.anexo3.tabla${i+1}T${j+3}`)
    }));
    if(this.metricaIndex >= columnas.length){
      this.metricaIndex = 0;
    }

    // La gráfica muestra un solo indicador a la vez (el primero por defecto)
    const campo = columnas[this.metricaIndex].field;
    const act = this.regiones.filter(r => r.visible);
    let datos;
    if(act.length === 1){
      this.labels = act[0].sucursales.map(r => r.description);
      datos = act[0].sucursales.map(r => r.measures[campo]);
    }else{
      this.labels = this.regiones.map(r => r.description);
      datos = act.map(r => r.measures[campo]);
    }
    this.data = [{
      name: this.metricas[this.metricaIndex].name,
      data: datos
    }];
  }
  /** Indicador que grafica la gráfica; el menú de tres puntos → Métrica lo cambia. */
  metricaChange(index: number){
    this.metricaIndex = index;
    this.getDataGrafica();
  }
  /** Columnas de clientes (conteo de personas) sin decimales; el resto (saldos, %) con 2. */
  decimalesCampo(field: string): number{
    return field.toLowerCase().includes('cliente') ? 0 : 2;
  }
  private getPeriodo(){
    const an = this.periodos.find(y => y.series.find(m => m.check));
    const mes = an.series.find(m => m.check);

    return `${mes.an}-${Meses.getMesesNum(mes.mes)}`;
  }
  private getPeridoAnt(){
    var anIn = this.periodos.findIndex(y => y.series.find(m => m.check));
    var an = this.periodos[anIn];

    var mesIn = an.series.findIndex(m => m.check);

    if(mesIn === 0 && anIn !== 0){
      anIn--;
      an = this.periodos[anIn];
      mesIn = an.series.length-1;
    }else if(anIn!==0){
      mesIn--;
    }
    var mes = an.series[mesIn];

    return `${mes.an}-${Meses.getMesesNum(mes.mes)}`;
  }
  borrarFiltros(){
    this.perspectives.forEach((p,i) =>{
      i===0?p.check=true:p.check=false;
    });
    this.viewTabla = true;
    this.selectAllSucursales = true;
    this.sucursales.forEach(s =>{
        s.check = this.selectAllSucursales;
    })
    this.expandAll = true;
    this.etiquetasShow = true;
    this.metricaIndex = 0;
    this.yearChange(this.periodoInicial);
  }
  yearChange(event){
    this.periodos.forEach( anio => {
      anio.series.forEach( per => {
        if(per.periodo === event.periodo){
          per.check = true;
          this.month = per.mesS;
          this.periodoSelect = per.periodo;
        }else{
          per.check = false;
        }
      });
    });
    this.expandAll = true;
    this.periodos = [...this.periodos];
    this.getData();
  }
  sucursalChange(sucClick){
    var sucursalesS = 0;
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = !this.viewTabla?true:!suc.check;
      }else if(!this.viewTabla){
        suc.check = false;
      }
      
      if(sucClick === 'consolidado'){
        suc.check = !this.selectAllSucursales;
      }
      if(suc.check){
        sucursalesS++;
      }
    }

    if(sucursalesS === this.sucursales.length && sucClick !== 'consolidado'){
      this.selectAllSucursales = true;
    }

    if(sucClick === 'consolidado'){
      this.selectAllSucursales = !this.selectAllSucursales;
    }
    this.sucursales = [...this.sucursales];
    if(sucursalesS !== 0) this.recalcularData();
  }
  async perspectiveChange(perClick){
    for( const suc of this.perspectives){
      if(suc.name === perClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    this.perspectives = [...this.perspectives];
    this.metricaIndex = 0;
    await this.getData();
  }

  getSubtitles(){
    // Orden: filtros / consolidado y, al final, el período (lo agrega el HTML)
    const partes: string[] = [];
    let esUnaSucursal = false;
    if(this.selectAllSucursales){
      partes.push(this.translate.instant('comercial.colocacion.anexo3.consolidado'));
    }else{
      const select = this.sucursales.filter(s => s.check);
      select.forEach(s => partes.push(s.name));
      esUnaSucursal = select.length === 1;
    }
    this.subtitles = partes.join(' | ');
    this.subtitles2 = esUnaSucursal
      ? [...partes, this.translate.instant('filtros.sucursales')].join(' | ')
      : this.subtitles;
  }
  changeGraph(type){
    this.viewTabla = false;
    this.type = type;
  }
  expandirElements(elemento){
    if(elemento === 'consolidado'){
      this.expandAll = !this.expandAll;
      this.regiones.forEach(r =>{
        r.check = this.expandAll;
      });
    }else{
      const r = this.regiones.find(r => r.description === elemento.description);
      r.check = !r.check;

      const rS = this.regiones.filter(r => r.check);
      if(rS.length === 0){
        this.expandAll = false;
      }else{
        this.expandAll = true;
      }
    }
  }

  exportExcel(){
    const data = [];
    var headers = [], formatos = [], aligment = [], titulo = '';
    this.perspectives.forEach( (per, posP) =>{
      if(per.check){
        titulo = per.name;
        headers.push(this.translate.instant(`comercial.colocacion.anexo3.tabla${posP+1}T${1}`))
        if(this.perspectives[0].check) headers.push(this.translate.instant(`comercial.colocacion.anexo3.tabla${posP+1}T${2}`))
        headers = headers.concat(per.columns.map((e, ii) => this.translate.instant(`comercial.colocacion.anexo3.tabla${posP+1}T${ii+3}`)));
        formatos = [
          FormatText.TEXT,
          ...(this.perspectives[0].check ? [FormatText.NUMBERDEC] : []),
          ...per.columns.map( e => FormatText.NUMBERDEC)
        ]
        aligment = [
          Aligment.LEFT,
          ...(this.perspectives[0].check ? [FormatText.NUMBERDEC] : []),
          ...per.columns.map( e => Aligment.RIGHT)
        ]
        this.regiones.forEach((r, p) =>{
          if(r.visible){
            const aux = [];
            aux.push(r.description);
            if(this.perspectives[0].check) aux.push(this.formaterPipe.transform(r.measures.carteraTotal,2,',','.'));
            aux.push(
              ...per.columns.map( e => r.measures[e.field])
            )
            data.push(aux);
            r.sucursales.forEach((s, p) =>{
              if(r.visible){
                const auxS = [];
                auxS.push(s.description);
                if(this.perspectives[0].check) auxS.push(this.formaterPipe.transform(s.measures.carteraTotal,2,',','.'));
                auxS.push(
                  ...per.columns.map( ss => s.measures[ss.field])
                )
                data.push(auxS);
              }
            });
          }
        });
      }
    });
    
    this.excelService.generateExcelSinTitulo(headers,data,titulo,aligment,formatos);
  }
  exportImage(){
    const titulos = {
      titulo: this.perspectives.find(p => p.check).name,
      subtitulo: this.perspectives.find(p => p.check).name,
      nombreArch: this.perspectives.find(p => p.check).name
    };
    this.graficas.exportImg(1,titulos)
  }
}
